import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store.js'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views Dashboard
const Dashboard = () => import('@/views/dashboard/Dashboard')

// Views Information
const Announcment = () => import('@/views/announcment/announcment')
// const Event = () => import('@/views/event/Events')
// const event_form = () => import('@/views/event/event_form')
// // const registration_form = () => import('@/views/event/registration_form')
// const event_detail = () => import('@/views/event/event_detail')
// const event_detail_participant = () => import('@/views/event/event_detail_participant')

//event
const event = () => import('@/views/event/event')
const event_detail = () => import('@/views/event/event_detail')
const event_detail_attendance = () => import('@/views/event/event_detail_attendance')
const event_form = () => import('@/views/event/event_form')
const event_form_description = () => import('@/views/event/event_form_description')
const event_registration = () => import('@/views/event/event_registration')
const event_registration_old = () => import('@/views/event/event_registration_old')
const event_order = () => import('@/views/event/event_order') //temp
const event_camera = () => import('@/views/event/event_camera')
const event_scan = () => import('@/views/event/event_scan')

const event_order_detail = () => import('@/views/event/event_order_detail')
const event_order_attendance = () => import('@/views/event/event_order_attendance')

const event_formfield_view = () => import('@/views/event/event_formfield_view')

//icare
const Icare = () => import('@/views/icare/Icare')
const CoachGroup = () => import('@/views/icare/CoachGroup')
const ReportIcare = () => import('@/views/icare/Report')
const icare_detail = () => import('@/views/icare/icare_detail')
const coach_group_detail = () => import('@/views/icare/coach_group_detail')
const icare_join = () => import('@/views/icare/icare_join') //who want join icare list
const icare_join_detail = () => import('@/views/icare/icare_join_detail')
const icare_people_detail = () => import('@/views/icare/icare_people_detail')
const icare_people_detail_group = () => import('@/views/icare/icare_people_detail_group')
const icare_people_without_icare = () => import('@/views/icare/icare_people_without_icare')

//visitor
const VisitorList = () => import('@/views/visitor/index')
///const VisitorDetail = () => import('@/views/visitor/detail')

//icare-youth
const IcareYouth = () => import('@/views/icare-youth/IcareYouth')
const CoachGroupYouth = () => import('@/views/icare-youth/CoachGroupYouth')
const ReportIcareYouth = () => import('@/views/icare-youth/ReportYouth')
const icare_detailYouth = () => import('@/views/icare-youth/icare_detail_youth')
const coach_group_detailYouth = () => import('@/views/icare-youth/coach_group_detail_youth')

//department
const Department = () => import('@/views/department/Department')
const department_detail = () => import('@/views/department/department_detail')
const department_join = () => import('@/views/department/department_join') //who want join icare list
const department_message = () => import('@/views/department/department_message') //who want join icare list

//Newcomer
const NewComer = () => import('@/views/newcomer/NewComer')
const NewComerReport = () => import('@/views/newcomer/newcomer_report')
const NewComerWantIcare = () => import('@/views/newcomer/newcomer_want_icare')

//Member
const Member = () => import('@/views/member/Member')
const member_detail = () => import('@/views/member/member_detail')
const MemberReport = () => import('@/views/member/member_report')
const MemberEditable = () => import('@/views/editable/index')

//ikids
const ikids_index = () => import('@/views/ikids/ikids')
const ikids_detail = () => import('@/views/ikids/ikidsdetail')
const ikids_graduate = () => import('@/views/ikids/ikids_graduate')
const kids_scan = () => import('@/views/ikids/kids_scan')
const kids_check = () => import('@/views/ikids/kids_check')
const kids_check_manual = () => import('@/views/ikids/kids_check_manual')
const kids_check_v2 = () => import('@/views/ikids/kids_check_v2')
const kids_check_new = () => import('@/views/ikids/kids_check_new')
const check_report = () => import('@/views/ikids/check_report')
const kids_queue = () => import('@/views/ikids/kids_queue')
const kids_class = () => import('@/views/ikids/kids_class')
const kids_class_new = () => import('@/views/ikids/kids_class_new')
const kids_class_v2 = () => import('@/views/ikids/kids_class_v2')
const parent_page = () => import('@/views/ikids/parent_page')
const parent_page_self_checkin = () => import('@/views/ikids/parent_page_self_checkin')
const parent_page_self_service = () => import('@/views/ikids/parent_page_self_service')
const parent_page_self_service_v2 = () => import('@/views/ikids/parent_page_self_service_v2')
const qr_print = () => import('@/views/ikids/qr_print')
const usher_page = () => import("@/views/ikids/usher_page");
const usher_page_new = () => import("@/views/ikids/usher_page_new");
const usher_page_v2 = () => import("@/views/ikids/usher_page_v2");
const usher_page_scan = () => import("@/views/ikids/usher_page_scan");
const usher_page_scan1 = () => import("@/views/ikids/usher_page_scan1");

//manage user
const role_index = () => import('@/views/role/index')
const role_assign_user = () => import('@/views/role/assign_user')
const role_assign_permission = () => import('@/views/role/assign_permission')

//manage system rules
const system_rules = () => import('@/views/system-rules/systemrules')

const systemsettings = () => import('@/views/systemsettings/systemsettings')

const notification_logs = () => import('@/views/notificationlogs/NotificationLogs')

const documentation = () => import('@/views/documentation/Documentation')

const planted_audit_info = () => import('@/views/plantedaudit/PlantedAuditInfo')

// certificate management
const CertificateList = () => import('@/views/certificate/CertificateList')
const CertificateCreate = () => import('@/views/certificate/CertificateCreate')
const CertificateSettings = () => import('@/views/certificate/CertificateSettings')

//master
const General = () => import('@/views/general-class/General')
const Keperluan = () => import('@/views/keperluan/Keperluan')
const Tujuan = () => import('@/views/tujuan/Tujuan')
const Category = () => import('@/views/member-kategori/Category')
const Service = () => import('@/views/service/Service')
const Services = () => import('@/views/service-type/servicetype')
const Satelite = () => import('@/views/satelite-church/Satelite')
const Zone = () => import('@/views/zona/Zone')
const Class = () => import('@/views/class/Class')
const Clasification = () => import('@/views/class-classification/ClassClassification')
const Kids = () => import('@/views/kids-report/kids')
const Link = () => import('@/views/link-content/Link')
const link_order = () => import('@/views/link-content/link_order')
const Section = () => import('@/views/section/Section')
const section_order = () => import('@/views/section/section_order')
const CategorySermon = () => import('@/views/categorysermon/CategorySermon')

//article

const Article = () => import('@/views/article-content/Article')
const article_form = () => import('@/views/article-content/article_form')
const article_detail = () => import('@/views/article-content/article_detail')
const ArticleCategory = () => import('@/views/article-category/article_category')
const article_category_form = () => import('@/views/article-category/article_category_form')
const article_category_position = () => import('@/views/article-category/article_position')
const article_category_detail = () => import('@/views/article-category/article_category_detail')
const article_content_position = () =>import("@/views/article-category/article_position_content");

const Banner = () => import('@/views/banner/Banner')
const banner_form = () => import('@/views/banner/banner_form')

//discover
const discover = () => import('@/views/discover/discover')
const discover_order = () => import('@/views/discover/discover_order')
const discover_form = () => import('@/views/discover/discover_form')
const discover_webview = () => import('@/views/discover/discover_webview')

//class batch
const curriculumList = () => import("@/views/onlineclass/curriculum");
const curriculumDetail = () => import("@/views/onlineclass/curriculum_detail");
const ClassList = () => import("@/views/onlineclass/Class");
const schedule = () => import("@/views/onlineclass/schedule");
const schedule_form = () => import("@/views/onlineclass/schedule_form");
const schedule_detail = () => import("@/views/onlineclass/schedule_detail");
const schedule_detail_attendance = () => import("@/views/onlineclass/schedule_detail_attendance");
const schedule_participant_curriculum = () => import("@/views/onlineclass/schedule_participant_curriculum");

//tools
const kids_report = () => import('@/views/tools/kids_report')
const hod_list = () => import('@/views/tools/hod_report')
const icl_list = () => import('@/views/tools/icl_report')
const icare_core_teams = () => import('@/views/tools/icare_core_teams_report')
const icare_member = () => import('@/views/tools/icare_member_report')
const department_core_teams = () => import('@/views/tools/department_core_teams')

//prayer
const prayer_index = () => import('@/views/prayer/index')
const prayer_detail = () => import('@/views/prayer/detail')

//ogin
const Login = () => import('@/views/login/Login')

//reset password
//const reset_password = () => import('@/views/reset-password/reset_password')
const setpassword = () => import('@/views/pages/SetPassword')
const AccountActivation = () => import('@/views/pages/AccountActivation')
const ForgotPassword = () => import('@/views/pages/ForgotPassword')

const Charts = () => import('@/views/dashboard/charts/Charts')
const Widgets = () => import('@/views/dashboard/widgets/Widgets')
// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')

const Register = () => import('@/views/pages/Register')

const assignteacher = () => import('@/views/onlineclass/assignteacher')
const class_teacher = () => import('@/views/onlineclass/class_teacher')
const resultkaruniarohani = () => import('@/views/onlineclass/resultkaruniarohani')
const karuniarohani_detail = () => import('@/views/onlineclass/karuniarohani_detail')
const resultdisc = () => import('@/views/onlineclass/resultdisc')
const disc_detail = () => import('@/views/onlineclass/disc_detail')
const resultquizkomunikasi = () => import('@/views/onlineclass/resultquizkomunikasi')
const quizkomunikasi_detail = () => import('@/views/onlineclass/quizkomunikasi_detail')
const resultkesehatanrohani = () => import('@/views/onlineclass/resultkesehatanrohani')
const kesehatanrohani_detail = () => import('@/views/onlineclass/kesehatanrohani_detail')


const peoples = () => import('@/views/peoples/peoples')
const peoples_users_register = () => import('@/views/peoples/people_user_register')

const reportview = () => import("@/views/report/reportview");
const reportview_icareattendance = () =>import("@/views/report/reportview_icareattendance");
const reportview_event_attendance = () => import("@/views/report/reportview_event_attendance");
const reportview_ikid_attendance = () => import("@/views/report/reportview_ikid_attendance");

// #DEV PAGE#
const dev_page = () => import('@/views/dev/dev_page')
const dev_page_class = () => import('@/views/dev/class/class')
const dev_page_schedule_detail_attendance = () => import("@/views/dev/class/schedule_detail_attendance");
const dev_peoples = () => import('@/views/dev/peoples/index')
const dev_people_detail = () => import('@/views/dev/peoples/detail')
const dev_people_logs_sync = () => import('@/views/dev/people_logs_sync/index')
const dev_files_manager_categories = () => import('@/views/dev/files_manager/CategoryList')
const dev_files_manager_files = () => import('@/views/dev/files_manager/FileList')

// temp page
const account_deletion = () => import('@/views/pages/AccountDeletion') // static page with no function to use to playstore requirement publish

const ikids_moving_up_class = () => import('@/views/ikids/moving_up_class.vue')

Vue.use(Router)

export const router = new Router({
  mode: 'hash',
  routes:  [
    {
    path: '/',
    name: 'Home',
    redirect: '/dashboard',
    component: TheContainer,
    meta: { requiresAuth: true },
    children: [
    {
      path: '/certificate',
      component: { render (c) { return c('router-view') } },
      children: [
        { path: '', name: 'Certificate List', component: CertificateList, meta: { permissionName: 'View certificates' } },
        { path: 'create', name: 'Create Certificate', component: CertificateCreate, meta: { permissionName: 'Generate certificates' } },
        { path: 'settings', name: 'Certificate Settings', component: CertificateSettings, meta: { permissionName: 'Manage certificate settings' } }
      ]
    },
    {
      path: '/',
      redirect: '/dashboard',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        }],
    },
    {
      path: '/role',
      redirect: '/role',
      name: 'Role Page',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '/role',
          name: 'Role',
          component: role_index
        },
        {
          path: 'view',
          name: 'Page5001',
          component: Page500
        },
        {
          path: 'assign-user',
          name: 'Assign User',
          component: role_assign_user
        },
        {
          path: 'assign-permission',
          name: 'Assign Permission',
          component: role_assign_permission
        },
      ]
    },
    {
      path: '/systemsettings',
      redirect: '/systemsettings',
      name: 'System Setting',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '/systemsettings',
          name: 'System Settings',
          component: systemsettings
        },
      ]
    },
    {
      path: '/notification-logs',
      redirect: '/notification-logs',
      name: 'Notification Logs Page',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '/notification-logs',
          name: 'Notification Logs',
          component: notification_logs,
          meta: { permissionName: 'View notification logs' }
        },
      ]
    },
    {
      path: '/documentation',
      redirect: '/documentation',
      name: 'Documentation Page',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '/documentation',
          name: 'Documentation',
          component: documentation
        },
      ]
    },
    {
      path: '/planted-audit-info',
      redirect: '/planted-audit-info',
      name: 'Planted Audit Info Page',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '/planted-audit-info',
          name: 'On/Off Planted Information',
          component: planted_audit_info,
          meta: { permissionName: 'View planted audit' }
        },
      ]
    },
    {
      path: '/systemrules',
      redirect: '/systemrules',
      name: 'SystemRules Page',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '/systemrules',
          name: 'SystemRules',
          component: system_rules
        },
      ]
    },
    {
      path: '/',
      redirect: '/announcment',
      name: 'Information Page',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'announcment',
          name: 'Announcment Page',
          component: Announcment
        }]
    },
    {
      path: '/',
      redirect: '/event',
      name: 'Information Page ',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'event',
          name: 'Event Page',
          component: event
        },
        {
          path: 'event_form',
          name: 'Event Form',
          component: event_form
        },
        {
          path: 'event_form_description',
          name: 'Event Form Description',
          component: event_form_description
        },
        // {
        //   path: 'registration_form',
        //   name: 'Registration Form',
        //   component: registration_form
        // },
        {
          path: 'event_detail',
          name: 'Event Detail',
          component: event_detail
        },
        // {
        //   path: 'event_detail_attendance',
        //   name: 'Event Detail Attendance',
        //   component: event_detail_attendance
        // },
        {
          path: 'event_order',
          name: 'Event Order',
          component: event_order
        },
      ]
    },
      {
      path: 'member',
      redirect: '/member/member',
      name: 'Member Page',
      component: {
        render (c) { return c('router-view') }
        },
          children: [
          {
          path: 'member',
          name: 'Member',
          component: Member
          },
          {
          path: 'member_detail',
          name: 'Member Detail',
          component: member_detail
          },

          {
          path: 'member_report',
          name: 'Member Report',
          component: MemberReport
          },
          // {
          //   path: 'member_editable',
          //   name: 'Member Editable',
          //   component: MemberEditable
          //   },
          ]
      },
      {
        path: 'newcomer',
        redirect: '/newcomer/newcomer',
        name: 'Newcomer Page',
        component: {
          render (c) { return c('router-view') }
          },
            children: [
            {
            path: 'newcomer',
            name: 'New Comers',
            component: NewComer
            },
            {
            path: 'newcomer_report',
            name: 'Newcomer Report',
            component: NewComerReport
            },            {
              path: 'newcomer_want_icare',
              name: 'Newcomer Want Icare',
              component: NewComerWantIcare
            }]
        },
        {
          path: 'icare',
          redirect: 'icare/coachgroup',
          component: {
            render (c) { return c('router-view') }
          },
            children: [
              {
                path: 'coachgroup',
                name: 'Coach Group',
                component: CoachGroup
              },
              {
                path: 'icare',
                name: 'List iCares',
                component: Icare
              },
            // {
            //   path: 'CoachGroup',
            //   name: 'Coach Group',
            //   component: CoachGroup
            // },
            // {
            //   path: 'coach_group_detail',
            //   name: 'Coach Group Detail',
            //   component: coach_group_detail
            //   },
            {
              path: 'icare_detail',
              name: 'iCare Detail',
              component: icare_detail
              },
            {
              path: 'report',
              name: 'iCare Report',
              component: ReportIcare
            },
            {
              path: 'visitor',
              name: 'Visitor',
              component: VisitorList
            },
            {
              path: 'icare_join',
              name: 'want join icare',
              component: icare_join
            },
              {
                path: 'icare_join/:id',
                name: 'want join icare detail',
                component: icare_join_detail
              },
              {
                path: 'coach_group_detail',
                name: 'Coach Group Detail',
                component: coach_group_detail
              },
              {
                path: 'icare_people_detail',
                name: 'iCare People Detail',
                component: icare_people_detail
              },
            {
              path: 'icare_people_detail/:id',
              name: 'iCare People Detail Group',
              component: icare_people_detail_group
            },
            {
              path: 'icare_people_without_icare',
              name: 'iCare People Without iCare',
              component: icare_people_without_icare
            },
            ]
        },

        {
          path: 'icare-youth',
          redirect: 'icare-youth/coachgroupyouth',
          component: {
            render (c) { return c('router-view') }
          },
            children: [
              {
                path: 'coachgroupyouth',
                name: 'Coach Group Youth',
                component: CoachGroupYouth
              },
              {
                path: 'icareyouth',
                name: 'Icare Youth',
                component: IcareYouth
              },
              {
                path: 'coach_group_detail_youth',
                name: 'Coach Group Detail Youth',
                component: coach_group_detailYouth
                },
              {
                path: 'icare_detail_youth',
                name: 'iCare Detail Youth',
                component: icare_detailYouth
              },
              {
                path: 'reportyouth',
                name: 'iCare Youth Report',
                component: ReportIcareYouth
              }
              ]
        },

        {
          path: 'onlineclass',
          redirect: 'onlineclass/curriculumlist',
          name: 'Online Class Page',
          component: {
            render (c) { return c('router-view') }
          },
            children: [
              {
                path: 'resultkaruniarohani',
                name: 'Result Karunia Rohani',
                component: resultkaruniarohani
              },
              {
                path: 'karuniarohani_detail',
                name: 'Detail Karunia Rohani',
                component: karuniarohani_detail
              },
              {
                path: 'resultdisc',
                name: 'Result DISC',
                component: resultdisc
              },
              {
                path: 'disc_detail',
                name: 'Detail Disc',
                component: disc_detail
              },
              {
                path: 'resultquizkomunikasi',
                name: 'Result Quiz Komunikasi',
                component: resultquizkomunikasi
              },
              {
                path: 'quizkomunikasi_detail',
                name: 'Detail Quiz Komunikasi',
                component: quizkomunikasi_detail
              },
              {
                path: 'class_teacher',
                name: 'Class Teacher',
                component: class_teacher
              },
              {
                path: 'assignteacher',
                name: 'Assign Teacher',
                component: assignteacher
              },
              {
                path: 'resultkesehatanrohani',
                name: 'Result Kesehatan Rohani',
                component: resultkesehatanrohani
              },
              {
                path: 'kesehatanrohani_detail',
                name: 'Detail Kesehatan Rohani',
                component: kesehatanrohani_detail
              },
              {
               path: "curriculumlist",
               name: "Curriculum List",
               component: curriculumList,
               },
               {
                  path: "class_curriculum_detail",
                  name: "Curriculum Detail",
                  component: curriculumDetail,
               },
               {
                  path: "classlist",
                  name: "Class List",
                  component: ClassList,
               },
               {
                  path: "schedule",
                  name: "Schedule",
                  component: schedule,
               },
               {
                  path: "schedule_form",
                  name: "Schedule Form",
                  component: schedule_form,
               },
               {
                  path: "schedule_detail",
                  name: "Schedule Detail",
                  component: schedule_detail,
               },
              ]
        },
        {
          path: 'ikids',
          redirect: 'ikids/listkids',
          name: 'iKids Page',
          component: {
            render (c) { return c('router-view') }
          },
            children: [
              {
                path: 'listkids',
                name: 'List Kids',
                component: ikids_index,
                meta: { permissionName: "View kid (including print barcode)" },
              },
              {
                path: 'detail',
                name: 'Detail Kids',
                component: ikids_detail,
              },
              {
                path: 'graduate',
                name: 'List Kids Graduate',
                component: ikids_graduate,
              },
              {
                path: 'kids-check',
                name: 'Kids Check',
                component: kids_check_new
              },
              {
                path: 'kids-check-manual',
                name: 'Kids Check Manual',
                component: kids_check_manual
              },
              {
                path: 'kids-check-old-1',
                name: 'Kids Check Old 1',
                component: kids_check_manual
              },
              {
                path: 'kids-check-old',
                name: 'iKid Check Old',
                component: kids_check
              },
              {
                path: 'kids-check-v2',
                name: 'Kids Check V2',
                component: kids_check_v2
              },
              {
                path: 'kids-check-new',
                name: 'Kids Check New',
                component: kids_check_new
              },
              {
                path: 'kids-scan',
                name: 'Kids Scan',
                component: kids_scan
              },
              {
                path: 'check-report',
                name: 'Ikids Check Report',
                component: check_report
              },
              {
                path: 'kids-queue',
                name: 'Kids Queue',
                component: kids_queue
              },
              {
                path: 'moving-up-class',
                name: 'Moving Up Class',
                component: ikids_moving_up_class
              },
             ]
          },


      {
        path: 'department',
        redirect: 'department/department',
        name: 'Department Page',
        component: {
          render (c) { return c('router-view') }
        },
        children: [
          {
            path: 'department',
            name: 'Department',
            component: Department
          },
          {
            path: 'department_detail',
            name: 'Department Detail',
            component: department_detail
          },
          {
            path: 'department_join',
            name: 'Want Join Ministry',
            component: department_join
          },
          {
            path: 'department_message',
            name: 'Ministry Message',
            component: department_message
          },
        ]
        },
        {
          path: 'service',
          redirect: 'service/service',
          name: 'Service Page',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'service',
              name: 'Service',
              component: Service
            },]
          },
        {
            path: 'peoples',
            redirect: 'peoples/peoples',
            name: 'Peoples Page',
            component: {
              render (c) { return c('router-view') }
            },
            children: [
              {
                path: 'peoples',
                name: 'Peoples',
                component: peoples
              },
              {
                path: 'users_register',
                name: 'Users List Register',
                component: peoples_users_register
              },
              ]
            },
          {
            path: 'prayer',
            redirect: 'prayer/listprayer',
            name: 'Prayer Page',
            component: {
              render (c) { return c('router-view') }
            },
              children: [
                {
                  path: 'listprayer',
                  name: 'List Prayer',
                  component: prayer_index,
                },
                {
                  path: 'detailprayer',
                  name: 'Prayer Detail',
                  component: prayer_detail,
                },
                ]
            },


        {
          path: 'master',
          redirect: '/master/general',
          name: 'Master Page',
          component: {
            render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'general',
                  name: 'General Class',
                  component: General
                },
                {
                  path: 'keperluan',
                  name: 'Newcomer - Keperluan',
                  component: Keperluan
                },
                {
                  path: 'tujuan',
                  name: 'Newcomer - Tujuan',
                  component: Tujuan
                },
                {
                  path: 'category',
                  name: 'Member - Category',
                  component: Category
                },
                {
                  path: 'services',
                  name: 'Services',
                  component: Services
                },
                {
                  path: 'satelite',
                  name: 'Satelite Church',
                  component: Satelite
                },
                {
                  path: 'zone',
                  name: 'Zone',
                  component: Zone
                },
                {
                  path: 'class',
                  name: 'iKids - Class',
                  component: Class
                },
                {
                  path: 'clasification',
                  name: 'iKids - Clasification',
                  component: Clasification
                },
                // {
                //   path: 'section',
                //   name: 'Section',
                //   component: Section
                // },
                {
                  path: 'section',
                  redirect: '/master/section',
                  name: 'Section',
                  component:
                    {
                      render (c) { return c('router-view') }
                    },
                    children: [
                      {
                        path: '/master/section',
                        name: 'Section Table',
                        component: Section
                      },
                      // {
                      //   path: 'order',
                      //   name: 'Section Order',
                      //   component: section_order
                      // },
                      {
                        path: 'order',
                        redirect: '/master/section/order/section',
                        name: 'Order',
                        component:
                          {
                            render (c) { return c('router-view') }
                          },
                          children: [
                            {
                              path: 'section',
                              name: 'Section Order',
                              component: section_order
                            },
                            {
                              path: 'linkcontent',
                              name: 'Link Content Order',
                              component: link_order
                            },
                          ]
                      },
                    ]
                },
                {
                  path: 'categorysermon',
                  name: 'Category Sermon',
                  component: CategorySermon
                },
                // {
                //   path: 'link',
                //   name: 'Link',
                //   component: Link
                // },
                {
                  path: 'link',
                  redirect: '/master/link',
                  name: 'Link Content',
                  component:
                    {
                      render (c) { return c('router-view') }
                    },
                    children: [
                      {
                        path: '/master/link',
                        name: 'Link Content Table',
                        component: Link
                      },
                      // {
                      //   path: 'order',
                      //   name: 'Link Content Order',
                      //   component: link_order
                      // },
                    ]
                },
                {
                  path: 'article-category',
                  redirect: '/master/article-category',
                  name: 'Article Category',
                  component:
                    {
                      render (c) { return c('router-view') }
                    },
                    children: [
                      {
                        path: '/master/article-category',
                        name: 'Article Category Table',
                        component: ArticleCategory
                      },
                      {
                        path: 'article-category/form',
                        name: 'Article Category Form',
                        component: article_category_form
                      },
                      {
                        path: 'article-category/detail',
                        name: 'Article Category Detail',
                        component: article_category_detail
                      },
                      {
                        path: 'article-category/position',
                        name: 'Article Category Position',
                        component: article_category_position
                      },
                      {
                        path: "article-category/position-content",
                        name: "Article Content Position",
                        component: article_content_position,
                      },
                    ]
                  },
                  {
                    path: 'article',
                    redirect: '/master/article',
                    name: 'Article',
                    component:
                      {
                        render (c) { return c('router-view') }
                      },
                      children: [
                        {
                          path: '/master/article',
                          name: 'Article Table',
                          component: Article
                        },
                        {
                          path: 'article/form',
                          name: 'Article Form',
                          component: article_form
                        },
                        {
                          path: 'article/detail',
                          name: 'Article Detail',
                          component: article_detail
                        },

                      ]
                    },
                  {
                    path: 'banner',
                    redirect: '/master/banner',
                    name: 'Banner',
                    component:
                      {
                        render (c) { return c('router-view') }
                      },
                      children: [
                        {
                          path: '/master/banner',
                          name: 'Banner Table',
                          component: Banner
                        },
                        {
                          path: 'banner/form',
                          name: 'Banner Form',
                          component: banner_form
                        },
                        // {
                        //   path: 'article/detail',
                        //   name: 'Article Detail',
                        //   component: article_detail
                        // },

                      ]
                    },
                {
                  path: 'discover',
                  redirect: '/master/discover',
                  name: 'Discover',
                  component:
                    {
                      render (c) { return c('router-view') }
                    },
                    children: [
                      {
                        path: '/master/discover',
                        name: 'Discover Table',
                        component: discover
                      },
                      {
                        path: 'discover/order',
                        name: 'Discover Order',
                        component: discover_order
                      },
                      {
                        path: 'discover/form',
                        name: 'Discover Form',
                        component: discover_form
                      },
                    ]
                  },
              ]
              },
          {
            path: '/tools',
            redirect: '/tools/kids_report',
            name: 'Tools Page',
            component: {
              render (c) { return c('router-view') }
                },
                children: [
                  {
                    path: 'kids_report',
                    name: 'Kids Report',
                    component: kids_report
                  },]
                },
          {
            path: '/tools',
            redirect: '/tools',
            name: 'Tools Page',
            component: {
              render (c) { return c('router-view') }
                },
                children: [
                  {
                    path: 'icl_list',
                    name: 'ICL List',
                    component: icl_list
                  },]
                },
          {
            path: '/tools',
            redirect: '/tools',
            name: 'Tools Page',
            component: {
              render (c) { return c('router-view') }
                },
                children: [
                  {
                    path: 'hod_list',
                    name: 'HOD List',
                    component: hod_list
                  },]
                },
            {
              path: '/tools',
              redirect: '/tools',
              name: 'Tools Page',
              component: {
                render (c) { return c('router-view') }
                  },
                  children: [
                    {
                      path: 'icare_core_teams',
                      name: 'Icare Core Teams',
                      component: icare_core_teams
                    },]
                  },
                  {
                    path: '/tools',
                    redirect: '/tools',
                    name: 'Tools Page',
                    component: {
                      render (c) { return c('router-view') }
                        },
                        children: [
                          {
                            path: 'icare_member',
                            name: 'Icare Member',
                            component: icare_member
                          },]
                        },
            {
              path: '/tools',
              redirect: '/tools',
              name: 'Tools Page',
              component: {
                render (c) { return c('router-view') }
                  },
                  children: [
                    {
                      path: 'department_core_teams',
                      name: 'Department Core Teams',
                      component: department_core_teams
                    },]
            },
            ]
     },
     {
      path: '/',
      redirect: '/login',
      component: {
        render (c) { return c('router-view') }
          },
          children: [

              {
                path: 'login',
                name: 'Login',
                component: Login
              },
            ]
    },
    // {
    //   path: '/',
    //   redirect: '/reset-password',
    //   component: {
    //     render (c) { return c('router-view') }
    //       },
    //       children: [

    //           {
    //             path: 'reset_password',
    //             name: 'Reset Password',
    //             component: reset_password
    //           },
    //         ]
    // },
    {
      path: '/',
      redirect: '/setpassword',
      component: {
        render (c) { return c('router-view') }
          },
          children: [
              {
                path: 'setpassword',
                name: 'Set Password',
                component: setpassword
              },
            ]
    },
    {
      path: '/',
      redirect: '/account-activation',
      component: {
        render (c) { return c('router-view') }
          },
          children: [
              {
                path: 'account-activation',
                name: 'Account Activation',
                component: AccountActivation
              },
            ]
    },
    {
      path: '/reportview',
      redirect: '/reportview',
      component: {
        render (c) { return c('router-view') }
          },
          children: [
              {
                path: 'icare',
                name: 'Report Montly Icare',
                component: reportview
              },
              {
                path: 'icare_attendance',
                name: 'Report Montly Icare Attendance',
                component: reportview_icareattendance
              },
              {
               path: "event_attendance",
               name: "Report Event Attendance",
               component: reportview_event_attendance,
              },
              {
                path: 'ikid_attendance',
                name: 'Report Montly Ikid Attendance',
                component: reportview_ikid_attendance
              },
            ]
    },
    {
      path: "/",
      redirect: "/schedule_detail_attendance",
      //meta: { requiresAuth: true },
      component: {
         render(c) {
            return c("router-view");
         },
      },
      children: [
         {
            path: "schedule_detail_attendance",
            name: "Schedule Detail Attendance",
            component: schedule_detail_attendance,
         },
      ],
   },
   {
    path: "/",
    redirect: "/schedule_participant_curriculum",
    //meta: { requiresAuth: true },
    component: {
       render(c) {
          return c("router-view");
       },
    },
    children: [
       {
          path: "schedule_participant_curriculum",
          name: "Schedule Participant Curriculum",
          component: schedule_participant_curriculum,
       },
    ],
 },
    {
      path: '/',
      redirect: '/event-registration',
      component: {
        render (c) { return c('router-view') }
          },
          children: [
              {
                path: 'event-registration',
                name: 'Event Registration',
                component: event_registration
              },

            ]
    },
    // {
    //   path: '/',
    //   redirect: '/event-registration-old',
    //   component: {
    //     render (c) { return c('router-view') }
    //       },
    //       children: [
    //           {
    //             path: 'event-registration-old',
    //             name: 'Event Registration old',
    //             component: event_registration_old
    //           },

    //         ]
    // },
    {
      path: '/',
      redirect: '/event-camera',
      component: {
        render (c) { return c('router-view') }
          },
          children: [
              {
                path: 'event-camera',
                name: 'Event Camera',
                component: event_camera
              },
            ]
    },
    {
      path: '/',
      redirect: '/event-scan',
      component: {
        render (c) { return c('router-view') }
          },
          children: [
              {
                path: 'event-scan',
                name: 'Event Scan',
                component: event_scan
              },
            ]
    },
    {
      path: '/ikids',
      redirect: '/',
      component: {
        render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'kids-class',
              name: 'Kids Class',
              component: kids_class_new
            },
            {
              path: 'kids-class-old',
              name: 'Kids Class Old',
              component: kids_class
            },
            {
              path: 'kids-class-new',
              name: 'Kids Class New',
              component: kids_class_new
            },
            {
              path: 'kids-class-v2',
              name: 'Kids Class V2',
              component: kids_class_v2
            },
            ]
    },

    {
      path: '/parent',
      redirect: '/',
      component: {
        render (c) { return c('router-view') }
          },
          children: [
              {
                path: 'selfcheckout',
                name: 'Parent Page',
                component: parent_page
              },
            ]
    },
    {
      path: '/parent',
      redirect: '/',
      component: {
        render (c) { return c('router-view') }
          },
          children: [
              {
                path: 'selfcheckin',
                name: 'Parent Page',
                component: parent_page_self_checkin
              },
            ]
    },
    {
      path: '/parent',
      redirect: '/',
      component: {
        render (c) { return c('router-view') }
          },
          children: [
              {
                path: 'selfservice',
                name: 'Parent Page',
                component: parent_page_self_service
              },
              {
                path: 'selfservice-v2',
                name: 'Parent Page V2',
                component: parent_page_self_service_v2
              },
            ]
    },
    {
      path: '/ikids',
      redirect: '/',
      component: {
        render (c) { return c('router-view') }
          },
          children: [
              {
                path: 'qr-print',
                name: 'QR Print',
                component: qr_print
              },
            ]
    },
    {
      path: '/dashboard',
      redirect: '/',
      component: {
        render (c) { return c('router-view') }
          },
          children: [
              {
                path: 'kidqueue',
                name: 'Usher Page',
                component: usher_page_new
              },
              {
                path: 'kidqueue-old',
                name: 'Usher Page Old',
                component: usher_page
              },
              {
                path: 'kidqueue-new',
                name: 'Usher Page New',
                component: usher_page_new
              },
              {
                path: 'kidqueue-v2',
                name: 'Usher Page V2',
                component: usher_page_v2
              }
            ]
    },
    {
      path: '/dashboard',
      redirect: '/',
      component: {
        render (c) { return c('router-view') }
          },
          children: [
              {
                path: 'kidqueue/scan',
                name: 'Usher Page',
                component: usher_page_scan
              }
            ]
    },
    {
      path: '/dashboard',
      redirect: '/',
      component: {
        render (c) { return c('router-view') }
          },
          children: [
              {
                path: 'kidqueue/scan1',
                name: 'Usher Page',
                component: usher_page_scan1
              }
            ]
    },
    {
      path: '/',
      redirect: '/event-order-detail',
      meta: { requiresAuth: true },
      component: {
        render (c) { return c('router-view') }
          },
          children: [
              {
                path: 'event-order-detail',
                name: 'Event Order Detail',
                component: event_order_detail
              },
            ]
    },
    {
      path: '/',
      redirect: '/event_detail_attendance',
      //meta: { requiresAuth: true },
      component: {
        render (c) { return c('router-view') }
          },
          children: [
              {
                path: 'event_detail_attendance',
                name: 'Event Detail Attendance',
                component: event_detail_attendance
              },
            ]
    },

    {
      path: '/',
      redirect: '/event-order-attendance',
      //meta: { requiresAuth: true },
      component: {
        render (c) { return c('router-view') }
          },
          children: [
              {
                path: 'event-order-attendance',
                name: 'Event Order Attendance',
                component: event_order_attendance
              },
            ]
    },
    {
      path: '/',
      redirect: '/event_formfield_view',
      meta: { requiresAuth: true },
      component: {
        render (c) { return c('router-view') }
          },
          children: [
              {
                path: 'event_formfield_view',
                name: 'Event Form Field View',
                component: event_formfield_view
              },
            ]
    },
    // {
    //   path: '/',
    //   redirect: '/master/discover/order',
    //   //meta: { requiresAuth: true },
    //   component: {
    //     render (c) { return c('router-view') }
    //       },
    //       children: [
    //           {
    //             path: '/master/discover/order',
    //             name: 'Discover Order',
    //             component: Discover_order
    //           },
    //         ]
    // },
    {
      path: '/',
      redirect: '/discover_webview',
      //meta: { requiresAuth: true },
      component: {
        render (c) { return c('router-view') }
          },
          children: [
              {
                path: '/discover_webview',
                name: 'Discover Webview',
                component: discover_webview
              },
            ]
    },
  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render (c) { return c('router-view') }
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: Page404
      },
      {
        path: '500',
        name: 'Page500',
        component: Page500
      },
      {
        path: 'register',
        name: 'Register',
        component: Register
      },
      {
        path: 'forgotpassword',
        name: 'Forgot Password',
        component: ForgotPassword
      }
    ]
  },
  // #DEV PAGE#
  {
    path: '/dev_page',
    redirect: '/dev_page',
    component: {
      render (c) { return c('router-view') }
        },
        children: [
            {
              path: '/dev_page',
              name: 'Dev Page',
              component: dev_page,
              meta: { requiresAuth: true, devDebugOnly: true }
            },
            {
              path: '/dev_page/class',
              name: 'Dev Page Class',
              component: dev_page_class,
              meta: { requiresAuth: true, devDebugOnly: true }
            },
            {
              path: '/dev_page/class/schedule_detail_attendance',
              name: 'Dev Page Class Schedule Detail Attendace',
              component: dev_page_schedule_detail_attendance,
              meta: { requiresAuth: true, devDebugOnly: true }
            },
            {
              path: '/dev_page/peoples',
              name: 'Dev Peoples',
              component: dev_peoples,
              meta: { requiresAuth: true, devDebugOnly: true }
            },
            {
              path: '/dev_page/peoples/:people_uuid',
              name: 'Dev People Detail',
              component: dev_people_detail,
              meta: { requiresAuth: true, devDebugOnly: true }
            },
            {
              path: '/dev_page/people-logs-sync',
              name: 'Dev People Logs Sync',
              component: dev_people_logs_sync,
              meta: { requiresAuth: true, devDebugOnly: true }
            },
            {
              path: '/dev_page/files-manager',
              name: 'Dev Files Manager',
              component: dev_files_manager_categories,
              meta: { requiresAuth: true, devDebugOnly: true }
            },
            {
              path: '/dev_page/files-manager/:category',
              name: 'Dev Files Manager Files',
              component: dev_files_manager_files,
              props: true,
              meta: { requiresAuth: true, devDebugOnly: true }
            },
          ]
  },
  {
    path: '/',
    redirect: '/account_deletion',
    component: {
      render (c) { return c('router-view') }
        },
        children: [
            {
              path: 'account_deletion',
              name: 'Account Deletion',
              component: account_deletion
            },
          ]
  },
]
})

router.beforeEach((to, from, next) => {
  store.commit('CLEAR_ERRORS')
  if (to.matched.some(record => record.meta.requiresAuth)) {
      let auth = store.getters.isAuth
      if (!auth) {
          next({ name: 'Login' })
      } else {
          next()
      }
  } else {
      next()
  }
})

router.beforeEach((to, from, next) => {
  console.log(to)
  if (to.matched.some(record => record.meta.permissionName)) {
    let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf(to.meta.permissionName) !== -1){
          next()
        }else{
          next({ name: 'Page500' })
        }
      }
  } else {
      next()
  }
})

router.beforeEach((to, from, next) => {
  if (!to.matched.some(record => record.meta.devDebugOnly)) {
    next()
    return
  }

  const proceedCheck = () => {
    const auth = store.state.user.authenticated || {}
    const email = (auth.email || '').toLowerCase()
    if (email === 'andrew.sulindra@gmail.com') {
      next()
      return
    }

    next({ name: 'Page404' })
  }

  if (store.getters.isAuth && (!store.state.user.authenticated || !store.state.user.authenticated.email)) {
    store.dispatch('user/getUserLogin')
      .then(() => {
        proceedCheck()
      })
      .catch(() => {
        next({ name: 'Page404' })
      })
    return
  }

  proceedCheck()
})
